"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var ExtEndpointModule_1 = __importDefault(require("../../ext/ExtEndpointModule"));
var ext_1 = require("../../util/ext");
var CommonExtWebPanelEndpointModule = /** @class */ (function (_super) {
    __extends(CommonExtWebPanelEndpointModule, _super);
    function CommonExtWebPanelEndpointModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showed = false;
        return _this;
    }
    CommonExtWebPanelEndpointModule.prototype.initEndpoint = function (adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var commonAdapter, container;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        commonAdapter = adapter;
                        return [4 /*yield*/, commonAdapter.getWebPanelContainer(this.extMain, this.extEndpoint)
                            // @ts-ignore
                        ];
                    case 1:
                        container = _a.sent();
                        // @ts-ignore
                        this.extFrame.iframe.style.width = '100%';
                        // @ts-ignore
                        this.extFrame.iframe.style.height = '100%';
                        // @ts-ignore
                        this.extFrame.iframe.style.border = 'none';
                        container.appendChild(this.extFrame.iframe);
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonExtWebPanelEndpointModule.prototype.statusNotice = function (extTypeIconInfo, adapter) {
        if (extTypeIconInfo) {
            this.extEndpoint.typeAuthority.extTypeIconInfo = extTypeIconInfo;
        }
        var _a = this.extEndpoint.typeAuthority.extTypeIconInfo, showFlag = _a.showFlag, cornerMarkUrl = _a.cornerMarkUrl, serverCurrentTime = _a.serverCurrentTime, countDown = _a.countDown;
        this.logger.info('showFlag', { showFlag: showFlag });
        if (showFlag & Number(ext_1.ShowFlag.ENTRANCE)) {
            this.logger.debug('显示入口');
            this.showExtEntrance(adapter);
        }
        else {
            this.logger.debug('隐藏入口');
            this.hideExtEntrance(adapter);
        }
        if (showFlag & Number(ext_1.ShowFlag.PANEL)) {
            this.logger.debug('显示面板');
            this.emit('postInitResolved');
            this.showPanel(adapter);
        }
        return Promise.resolve();
    };
    CommonExtWebPanelEndpointModule.prototype.textNotice = function (tips, adapter) {
        throw new Error("textNotice Method not implemented.");
    };
    CommonExtWebPanelEndpointModule.prototype.postInit = function (adapter) {
        var _this = this;
        var showFlag = this.extEndpoint.typeAuthority.extTypeIconInfo.showFlag;
        if (showFlag & ext_1.ShowFlag.PANEL) {
            return Promise.resolve();
        }
        else {
            return new Promise(function (resolve) {
                _this.once('postInitResolved', function () { return resolve(); });
            });
        }
    };
    CommonExtWebPanelEndpointModule.prototype.showEndpointPanel = function (adapter) {
        // 第一次show的时候才触发onLoad的生命周期
        if (!this.showed) {
            this.showed = true;
            this.postLifeLoad(adapter);
        }
        return Promise.resolve();
    };
    CommonExtWebPanelEndpointModule.prototype.hideEndpointPanel = function (adapter) {
        throw new Error("hideEndpointPanel Method not implemented.");
    };
    CommonExtWebPanelEndpointModule.prototype.renderEntrance = function (adapter) {
        var image = new Image(50, 50);
        image.src = this.extMain.extVersionDetail.extIcon;
        var div = document.createElement('div');
        div.id = "common_ext_panel_" + this.extMain.extName + "_" + this.extEndpoint.extType;
        div.style.width = '50px';
        div.style.height = '50px';
        div.style.borderRadius = '50%';
        div.style.cursor = 'pointer';
        div.appendChild(image);
        return div;
    };
    CommonExtWebPanelEndpointModule.prototype.showEndpointEntrance = function (adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var commonAdapter, entranceContainer, div;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        commonAdapter = adapter;
                        return [4 /*yield*/, commonAdapter.getWebPanelEntranceContainer(this.extMain, this.extEndpoint)];
                    case 1:
                        entranceContainer = _a.sent();
                        entranceContainer.innerHTML = '';
                        div = this.renderEntrance(adapter);
                        div.addEventListener('click', function () {
                            _this.emit('postInitResolved');
                            _this.sys_startup_ext_interactive(adapter);
                            _this.extFrame.load(adapter);
                            _this.showPanel(adapter);
                        });
                        entranceContainer.appendChild(div);
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonExtWebPanelEndpointModule.prototype.hideEndpointEntrance = function (adapter) {
        throw new Error("hideEndpointEntrance Method not implemented.");
    };
    CommonExtWebPanelEndpointModule.prototype.ready = function (adapter) {
        throw new Error("ready Method not implemented.");
    };
    CommonExtWebPanelEndpointModule.prototype.showSupError = function (msg, adapter) {
        throw new Error("showSupErrormMethod not implemented.");
    };
    CommonExtWebPanelEndpointModule.prototype.getModalContainer = function (adapter) {
        return Promise.resolve(document.body);
    };
    CommonExtWebPanelEndpointModule.prototype.close = function (content, adapter) {
        throw new Error("close Method not implemented.");
    };
    return CommonExtWebPanelEndpointModule;
}(ExtEndpointModule_1["default"]));
exports["default"] = CommonExtWebPanelEndpointModule;
